import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      y: ".375",
      fill: "#F8F8F8",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59AD3B",
      "fill-rule": "evenodd",
      d: "M33 13.956c-3.95 0-7.201 3.345-7.332 7.486v8.006c-.758-4.8-7.437-13.72-14.665-15.492L11 19.884c.225 3.625 2.172 4.79 4.823 5.777 3.545 1.388 9.11 3.465 9.845 8.108-2.315-4.045-9.833-6.23-13.976-6.202.265.98.618 1.867 1.084 2.671 1.424 2.459 3.99 4.373 6.782 4.373h4.887c2.791 0 5.358-1.914 6.782-4.372 1.261-2.178 1.708-4.972 1.773-8.537v-7.746Zm-10.998-2.582c1.687 0 3.055 1.445 3.055 3.227 0 1.783-1.368 3.228-3.055 3.228-1.688 0-3.056-1.445-3.056-3.228 0-1.782 1.368-3.227 3.055-3.227Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }